import { Box, Divider, Link, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

import { ControlledInputs } from '@/components';

import { useAddUserFormContext } from '../hooks';

export const AddUserDetailsForm = () => {
  const form = useAddUserFormContext();

  return (
    <Box>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: '1fr auto 1fr',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '12px',
          }}
        >
          <Typography variant="body2" color="textPrimary">
            Please note:
            <br />
            ChangeGPS Lite plans include up to 3 user licenses and Pro plans
            include up to 15. Modify your subscription{' '}
            <Link component={RouterLink} to="/settings/subscriptions">
              here
            </Link>
          </Typography>
          <ControlledInputs.TextField
            ControllerProps={{
              control: form.control,
              name: `email`,
            }}
            label="Email (username)"
          />
          <ControlledInputs.TextField
            ControllerProps={{
              control: form.control,
              name: `first_name`,
            }}
            label="First Name"
          />
          <ControlledInputs.TextField
            ControllerProps={{
              control: form.control,
              name: `last_name`,
            }}
            label="Last Name"
          />
        </Box>
        <Box>
          <Divider
            orientation="vertical"
            sx={{
              marginX: '28px',
            }}
          />
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '12px',
          }}
        >
          <ControlledInputs.TextField
            ControllerProps={{
              control: form.control,
              name: `position`,
            }}
            label="Company Position"
          />
          <ControlledInputs.FullTextToggleButton
            ControllerProps={{
              control: form.control,
              name: 'admin',
              defaultValue: '0',
            }}
            label="Access Permissions"
            options={[
              {
                label: 'Standard User',
                value: '0',
              },
              {
                label: 'Administrator',
                value: '1',
              },
            ]}
            ToggleButtonGroupProps={{
              onClick: (event) => {
                if (!('value' in event.target)) return;
              },
            }}
          />
          <Typography variant="body2" color="textSecondary">
            Administrators have permissions to modify company branding, settings
            and add/remove other user accounts.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};
